"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles = ({ shadows, palette, spacing }) => ({
    settingButton: {
        backgroundColor: palette.greyScaleDeprecated[7],
        boxShadow: shadows[2],
    },
    customDateRange: {
        borderRadius: 4,
        padding: '10px 8px',
        border: 'none',
        outline: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        lineHeight: 1,
        marginLeft: 8,
        '&:hover': {
            background: palette.grey.level2,
        },
    },
    filterButton: {
        '&.ho': {
            background: palette.background.primary,
            borderColor: palette.primary.main,
        },
    },
    filterClearButton: {
        position: 'absolute',
        top: -10,
        right: -10,
        background: palette.greyScaleDeprecated[2],
        fontSize: 17,
        fontWeight: 600,
        color: palette.greyScaleDeprecated[7],
        borderRadius: '50%',
        padding: 2,
        '&:hover': {
            background: palette.greyScaleDeprecated[1],
        },
    },
    filterNumberIcon: {
        color: palette.text.lightContrast,
        background: palette.primary.main,
        padding: 5,
        lineHeight: 0.8,
        fontSize: '14px !important',
        borderRadius: 4,
        position: 'relative',
    },
    flexColumn: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
    filtersContainer: {
        paddingTop: 20,
        marginLeft: 24,
    },
    dateRangeContainer: {
        marginLeft: 24,
    },
    groupBySpacer: {
        width: 0,
        height: 55,
        borderRight: `1px solid ${palette.grey.level3}`,
        marginTop: 5,
        marginRight: 16,
        marginLeft: 16,
    },
    root: {
        display: 'flex',
        padding: '10px 20px',
        backgroundColor: palette.color7.opacity30,
        alignItems: 'center',
        borderRadius: 0,
    },
    groupByTabName: {
        textTransform: 'capitalize',
    },
    reportsMenuLabel: {
        marginBottom: -2,
    },
    downloadButtonWrapper: {
        marginLeft: 'auto',
        fonySize: 14,
        display: 'flex',
        alignItems: 'center',
        gap: spacing(2),
    },
    downloadButton: {
        backgroundColor: palette.grey.level0,
        boxShadow: shadows[2],
        padding: 5,
    },
    downloadIcon: {
        marginRight: 5,
    },
});
exports.default = styles;
